import { render, staticRenderFns } from "./contentCourseLearnerEditScore.vue?vue&type=template&id=51726129&"
import script from "./contentCourseLearnerEditScore.vue?vue&type=script&lang=js&"
export * from "./contentCourseLearnerEditScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports